import React, { useEffect, type FC } from 'react';

import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel.ts';
import type { LoadingPriority } from '@confluence/loadable';
import { LoadablePaint, LoadingPriority as LoadingPriorityEnum } from '@confluence/loadable';

import { ObjectCommentContainer } from './ObjectCommentContainer.tsx';

type CommentTypes = {
	showGeneralComment?: boolean;
	pageWidthType?: string;
	loadingPriority?: LoadingPriority;
	showLabels: boolean;
	hasReactions: boolean;
	editorIsUserOffline?: boolean;
};

const ObjectCommentContainerLoader = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectCommentContainer" */ './ObjectCommentContainer.tsx'
			)
		).ObjectCommentContainer,
});

export const ObjectCommentWrapper: FC<CommentTypes> = ({
	showGeneralComment,
	pageWidthType,
	loadingPriority,
	showLabels,
	hasReactions,
	editorIsUserOffline,
}) => {
	const { setShowGeneralComments } = useCommentsPanelActions();

	useEffect(() => {
		setShowGeneralComments(showGeneralComment);
		// eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
	}, []);

	return loadingPriority === LoadingPriorityEnum.PAINT ? (
		<ObjectCommentContainerLoader
			pageWidthType={pageWidthType}
			showLabels={showLabels}
			hasReactions={hasReactions}
			editorIsUserOffline={editorIsUserOffline}
		/>
	) : (
		<ObjectCommentContainer
			pageWidthType={pageWidthType}
			showLabels={showLabels}
			hasReactions={hasReactions}
			editorIsUserOffline={editorIsUserOffline}
		/>
	);
};
